<template>
  <el-main class="container">
    <Nav>
      <div class="left" slot="left">
        <span>停车券列表</span>
      </div>
      <div class="right" slot="right">
        <!-- <el-button
          ype="primary"
          class="excel"
          :idRow="false"
          v-if="false"
          type="primary">
          设置新注册优惠券</el-button> -->
        <el-button
          v-show="hasAuthority('parkAddCoupon')"
          ype="primary"
          class="excel"
          :idRow="false"
          @click="handlerGo('add')"
          type="primary">
          新增停车券</el-button>
      </div>
    </Nav>
    <div class="table-box">
      <Table
        border
        :header-row-style="{height: '100px'}"
        :header-cell-style="{background:'#f4f4f4',color:'#606266'}"
        :row-style="{height: '150px'}"
        align="center"
        :column="column"
        :data="datasource.data"
        pagination
        background
        :paginationTop="'30px'"
        :paginationAlign="'center'"
        layout="prev, pager, next, sizes, jumper"
        :page-sizes="[5, 10, 20, 30]"
        :pager-count="5"
        :current-page.sync="body.pageIndex"
        :total="datasource.total"
        :page-size="body.pageSize"
        @size-change="handleSizeChange"
        @p-current-change="handleCurrentChange"
      >
      </Table>
    </div>
  </el-main>
</template>

<script>
import Nav from '@/components/nav'
import { getParkCouponList, deleteParkCoupon } from '@/api/park'
export default {
  data() {
    return {
      body: {
        pageSize: 5,
        pageIndex: 1
      },
      column: [
        {
          label: 'id',
          render: (h, scope) => {
            return (
              <span>{(scope.$index + 1) + (this.body.pageIndex - 1) * (this.body.pageSize)}</span>
            )
          }
        },
        {
          prop: 'title',
          label: '停车券名称'
        },
        {
          prop: 'type',
          label: '停车券类型',
          render: (h, scope) => {
            let text = ''
            scope.row.type === 0 ? text = '折扣券' : text = '面值券'
            return (
              <div>{text}</div>
            )
          }
        },
        {
          label: '停车券有效期',
          render: (h, scope) => {
            return (
              <div>
                <span>{scope.row.startDate}</span>&nbsp;&nbsp; ~ &nbsp;&nbsp;
                <span>{scope.row.endDate}</span>
              </div>
            )
          }
        },
        {
          label: '操作',
          width: '300',
          render: (h, scope) => {
            return (
              <div>
                <div>
                  <el-link v-show={this.hasAuthority('parkSendCoupon')} underline={false} type='primary' onClick={() => { this.handlerGo('sentParkCoupon', scope) }}>发送停车券</el-link>&nbsp;&nbsp;
                  <el-link v-show={this.hasAuthority('parkSendRecord')} underline={false} type='primary' onClick={() => { this.handlerGo('details', scope) }}>发送记录</el-link>&nbsp;&nbsp;
                </div>
                <div>
                  <el-link v-show={this.hasAuthority('parkEditCoupon')} underline={false} type='primary' onClick={() => { this.handlerGo('visit', scope) }}>编辑</el-link>&nbsp;&nbsp;
                  <el-link v-show={this.hasAuthority('parkDeleteCoupon')} underline={false} type='primary' onClick={() => { this.handlerGo('delete', scope) }}>删除</el-link>&nbsp;&nbsp;
                </div>
              </div>
            )
          }
        }
      ],
      config: {
        size: 10,
        fields: [
          {
            prop: 'title',
            label: '停车券名称'
          },
          {
            prop: 'type',
            label: '停车券类型',
            type: 'status',
            rule: [
              {
                value: 0,
                label: '折扣券'
              },
              {
                value: 1,
                label: '面值券'
              }
            ]
          },
          {
            prop: 'date',
            label: '停车券有效期'
          }
        ]
      },
      datasource: {
        total: 0,
        data: []
      }
    }
  },
  created() {
    this.network().getParkCouponList()
  },
  methods: {
    event() {
      return {
      }
    },
    network() {
      return {
        getParkCouponList: async() => {
          const { data } = await getParkCouponList(this.body)
          data.list.forEach((item, index) => {
            item.date = item.startDate + '~' + item.endDate
          })
          this.datasource.total = data.total
          this.datasource.data = data.list
        },
        deleteParkCoupon: async(uuid) => {
          await deleteParkCoupon(uuid)
          this.network().getParkCouponList(this.body)
        }
      }
    },
    handlerPageChange(data) {
      this.body.pageIndex = data.page
      this.network().getParkCouponList()
    },
    handlerGo(type, scope) {
      switch (type) {
        case 'details' : this.$router.push({
          path: 'park-coupon-management/send-details',
          query: {
            id: JSON.stringify(scope.row.uuid)
          }
        }); break
        case 'sentParkCoupon' :
          this.$router.push({
            path: `park-coupon-management/send-park-coupon/${scope.row.uuid}`,
            query: { info: JSON.stringify(scope.row) }
          }); break
        case 'visit' : this.$router.push({
          path: `park-coupon-management/set-park-coupon/${scope.row.uuid}`
        }); break
        case 'add' : this.$router.push('park-coupon-management/add-park-coupon'); break
        case 'delete':
          this.$confirm('确认删除该停车券?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
            center: true
          }).then(() => {
            this.network().deleteParkCoupon(scope.row.uuid)
            this.$message({
              type: 'success',
              message: '删除成功!'
            })
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除'
            })
          })
      }
    },
    handleSizeChange(val) {

    },
    handleCurrentChange() {

    }
  },
  components: {
    Nav
  }
}
</script>

<style scoped lang="scss">
.left{
  span{
    font-weight: bold;
    cursor: pointer;
  }
}
.row{
  width: 70%;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  flex-flow: row wrap;
  span{
    margin: 0 15px;
    color: rgb(85, 156, 223);
    cursor: pointer;
  }
}

Nav{
  margin-bottom: 10px;
}

/deep/ .table{
  /deep/ .el-table__body .el-table__row{
    height: 150px;
  }
}
</style>
